<template>
  <b-card title="Genel Bilgi">
    <b-row>
      <b-col cols="12">
        <category-select />
      </b-col>
      <b-col cols="12">
        <title-text />
      </b-col>
      <b-col cols="12">
        <content-text />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <status-select />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <ordering-number />
      </b-col>
      <b-col cols="12">
        <b-button
          variant="primary"
          @click="submitForm"
        >
          <FeatherIcon icon="SaveIcon" />
          Kaydet
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import TitleText from '@/views/Products/elements/ProductCard/TitleText.vue'
import ContentText from '@/views/Products/elements/ProductCard/ContentText.vue'
import CategorySelect from '@/views/Products/elements/ProductCard/CategorySelect.vue'
import StatusSelect from '@/views/Products/elements/ProductCard/StatusSelect.vue'
import OrderingNumber from '@/views/Products/elements/ProductCard/OrderingNumber.vue'

export default {
  name: 'ProductCard',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    ContentText,
    CategorySelect,
    StatusSelect,
    OrderingNumber,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
